<template>
    <b-card class="text-left">
      <br />
      <b-row>
        <b-col>
          <div class="preview-article-detail page">
            <div class="container">
              <div align="left">
                <h5 class="h5 mb-5 text-primary font-weight-bold">Article Preview</h5>
              </div>
              <div class="content-post-detail">
                <div class="content-post-image">
                    <img loading="lazy" :src="previewArticle.image" :alt="previewArticle.image_alt">
                </div>
                <div class="row">
                  <div class="col-md-7 content-post-published">
                      <span class="content-post-category tx-bold">{{this.previewArticle.category}}</span>
                      <span class="content-post-date">{{this.currentDate}}</span>
                  </div>
                  <div class="col-md-5 social-media-share ">
                    <span class="share-now-text">Bagikan Sekarang</span>
                    <a href="#" class="fab fa-twitter share-popup"></a>
                    <a href="#" class="fab fa-facebook-f share-popup"></a>
                    <a href="#" class="fab fa-linkedin-in share-popup"></a>
                    <a id="copy-url" class="fa fa-share-alt"></a>
                  </div>
                </div>
                <div class="content-post-title">
                  <h1>{{this.previewArticle.title}}</h1>
                </div>
                <div class="content-post-description" style="margin-bottom: 0;">
                  <span v-html="previewArticle.meta_description"></span>
                </div>
                <div class="content-cta-button text-center" v-if="previewArticle.is_with_quick_cta_button">
                  <a :href="previewArticle.quick_cta_button_url" target="_blank" class="btn bg-purple btn-primary-paxel">
                    {{this.previewArticle.quick_cta_button_text}}
                  </a>
                </div>
                <div class="content-post-description">
                  <span v-html="this.previewArticle.content"></span>
                  <div class="content-cta-button text-center" v-if="previewArticle.is_with_cta_button">
                    <a :href="previewArticle.cta_button_url" target="_blank" class="btn bg-purple btn-primary-paxel">
                      {{this.previewArticle.cta_button_text}}
                    </a>
                  </div>
                  <div class="row" style="display:flex;align-items:center;">
                    <span class="text-title-medium pr-3 mt-2 tx-bold">TAG:</span> 
                    <a v-for="tag in previewArticle.tags" :key="tag" href="#">
                      <span class="mr-2 mt-2 text-title-medium tx-semi-bold" style="color:#fff;background-color:#ff434f;padding:5px 10px; text-decoration: none;">{{tag}}</span>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
    </b-card>
</template>

<script>

export default {
  computed: {
    previewArticle() {
      return this.$session.get('previewArticle');
    },
    currentDate(){
      const now = new Date();
      return moment(now).format('D MMM YYYY');
    }
  },
};
</script>

<style scoped>
.content-post-detail .content-post-image {
    width: 100%;
}
.content-post-detail .content-post-image img {
    width: 100%;
    height: auto;
}
.content-post-detail img {
    border-radius: 10px;
}
.content-post-detail .content-post-description img {
    border-radius: 10px;
}
img {
    vertical-align: middle;
    border-style: none;
}
.content-post-detail .row {
    margin: 0;
    padding: 20px 0 10px 0;
}
.content-post-detail .content-post-published {
    padding: 0;
}
.content-post-detail .content-post-published span {
    font-size: 14px;
    color: #424143;
    padding: 10px 0px;
}
.content-post-detail .content-post-published .content-post-category {
    color: #424143;
    font-size: 14px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
    display: inline-block;
    text-transform: uppercase;
}
.content-post-detail .content-post-published .content-post-category::after {
    content: "";
    background-color: #9b9b9b;
    width: 2px;
    height: 20px;
    position: relative;
    display: inline-block;
    margin: 0 10px;
    top: 5px;
}
.content-post-detail .content-post-published span {
    font-size: 14px;
    color: #424143;
    padding: 10px 0px;
}
.content-post-detail .social-media-share {
    font-size: 20px;
    text-align: right;
    padding: 0;
}
.content-post-detail .social-media-share .share-now-text {
    padding: 10px;
    font-size: 12px;
    color: #9b9b9b;
    font-weight: bold;
    letter-spacing: 2px;
}
.content-post-detail .social-media-share .share-now-text::after {
    content: "";
    background-color: #9b9b9b;
    width: 40px;
    height: 1px;
    position: relative;
    display: inline-block;
    margin: 0 20px;
    bottom: 3px;
}
.content-post-detail .social-media-share a {
    width: 35px;
    height: 35px;
    padding: 0px;
    font-size: 20px;
    cursor: pointer;
    color: #9b9b9b;
    text-align: center;
    line-height: 1.55em;
    border-radius: 25px;
    text-decoration: none;
    -moz-border-radius: 25px;
    -webkit-border-radius: 25px;
    border: 2px solid #9b9b9b;
}
.content-post-detail .content-post-description {
    padding: 10px 0px;
    margin-bottom: 0;
}
.text-center {
    text-align: center!important;
}
a {
    color: #007bff;
    text-decoration: none;
    background-color: transparent;
}
.btn {
    display: inline-block;
    font-weight: 400;
    color: #212529;
    text-align: center;
    vertical-align: middle;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    background-color: transparent;
    border: 1px solid transparent;
    padding: 0.375rem 0.75rem;
    font-size: 1rem;
    line-height: 1.5;
    border-radius: 0.25rem;
    transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}
.bg-purple {
    background: #5e50a1;
}
.btn-primary-paxel {
    min-height: 48px !important;
    padding: 12px 20px !important;
    color: #5e50a1;
}
.btn.bg-purple, .btn.bg-yellow {
    color: #ffffff;
    font-size: 14px;
}
.content-post-detail .content-post-description {
    padding: 10px 0;
    margin-bottom: 100px;
}
.content-post-detail .row {
    margin: 0;
    padding: 20px 0 10px 0;
}
.text-title-medium {
    font-stretch: normal;
    font-style: normal;
    line-height: normal;
    letter-spacing: normal;
}
.tx-bold {
    font-weight: bold;
}
</style>
